/**
 * 轮播图相关API
 */
import request from '@/utils/request'

/**
 * 获取轮播图列表
 * @param {Object} params - 查询参数 { status: '1' } 只获取启用的轮播图
 * @returns {Promise} 若依格式 { code, msg, total, rows }
 */
export function getBannerList(params = {}) {
  return request({
    url: '/menu/banner/list',
    method: 'get',
    params: {
      status: '1', // 默认只获取启用的
      ...params
    }
  })
}

/**
 * 获取启用的轮播图列表（前端首页使用）
 * @returns {Promise} 返回启用的轮播图列表，按sortOrder排序
 */
export function getActiveBanners() {
  return request({
    url: '/menu/banner/list',
    method: 'get',
    params: {
      status: '1',
      isDeleted: '0',
      orderByColumn: 'sortOrder',
      isAsc: 'asc',
      pageSize: 20 // 获取更多轮播图
    }
  })
}

// 注意：目前只实现获取轮播图列表功能
// 其他功能（增删改）等以后需要时再添加
